import { type CertificateSubscriptionPrice } from '@mc/api'
import { hasDiscount } from 'pages/certificates/annualpass/data/subscriptionData'
import { type CmHeroPrice } from 'pages/certificates/experiments/mccerts-2548_v1-subscriptions-entry-point'

export const getPassMonthlyPrice = (
  pricing: CertificateSubscriptionPrice | undefined,
  suffix = '',
): CmHeroPrice => {
  const listPrice = pricing?.formattedMonthlyPriceRounded
  const netPrice = pricing?.formattedMonthlyNetPriceRounded
  const finalPrice = netPrice ?? listPrice
  if (!finalPrice) return {}

  return {
    finalPrice: `${finalPrice}${suffix}`,
    originalPrice: hasDiscount(netPrice, listPrice) ? listPrice : undefined,
  }
}
